import DesktopRatingHalfCard from './RatingHalfCard';

export default DesktopRatingHalfCard;
